// Helpers to build chart data from raw lists
import { format, subDays, parseISO, isValid } from "date-fns";

export function lastNDaysSeries(items, n = 7, dateKey = "created_at") {
  const days = [];
  const now = new Date();
  for (let i = n - 1; i >= 0; i--) {
    const d = subDays(now, i);
    days.push({
      date: format(d, "yyyy-MM-dd"),
      label: format(d, "MMM d"),
      value: 0,
    });
  }
  const map = Object.fromEntries(days.map((d) => [d.date, d]));
  for (const it of items || []) {
    const raw = it[dateKey];
    if (!raw) continue;
    let date;
    try {
      date =
        typeof raw === "string" ? parseISO(raw) : new Date(raw);
    } catch {
      continue;
    }
    if (!isValid(date)) continue;
    const key = format(date, "yyyy-MM-dd");
    if (map[key]) map[key].value += 1;
  }
  return days;
}

export function combineSeries(seriesList) {
  // seriesList: [{ key, items }]
  // returns array merged by label using lastNDaysSeries already computed
  if (!seriesList.length) return [];
  const base = seriesList[0].data.map((d) => ({
    label: d.label,
    [seriesList[0].key]: d.value,
  }));
  for (let i = 1; i < seriesList.length; i++) {
    seriesList[i].data.forEach((d, idx) => {
      base[idx][seriesList[i].key] = d.value;
    });
  }
  return base;
}

export function groupBy(items, keyFn) {
  const out = {};
  for (const it of items || []) {
    const k = keyFn(it) || "Unknown";
    out[k] = (out[k] || 0) + 1;
  }
  return out;
}

export function topNFromObj(obj, n = 6) {
  return Object.entries(obj)
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value)
    .slice(0, n);
}

export function statusCounts(items, key = "status") {
  const o = groupBy(items, (i) => i[key] || "submitted");
  return Object.entries(o).map(([name, value]) => ({ name, value }));
}

export function relativeTime(dateStr) {
  if (!dateStr) return "";
  const d = typeof dateStr === "string" ? parseISO(dateStr) : new Date(dateStr);
  if (!isValid(d)) return "";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return format(d, "MMM d, yyyy");
}
